import { render, staticRenderFns } from "./ReviewSectionForm.vue?vue&type=template&id=10aa3e96"
import script from "./ReviewSectionForm.vue?vue&type=script&lang=js"
export * from "./ReviewSectionForm.vue?vue&type=script&lang=js"
import style0 from "./ReviewSectionForm.vue?vue&type=style&index=0&id=10aa3e96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports